const transports = [];

export const severity = {
  debug: 7,
  info: 6,
  notice: 5,
  warning: 4,
  error: 3,
  critical: 2,
  alert: 1,
  emergency: 0
};

export const levelString = {
  7: 'debug',
  6: 'info',
  5: 'notice',
  4: 'warning',
  3: 'error',
  2: 'critical',
  1: 'alert',
  0: 'emergency'
};

async function executeSingleTransport(func, message, level, name) {
  try {
    await func(message, level);
  }
  catch (e) {
    console.error(`Unable to log through transport ${name}: ${JSON.stringify(e)}`);
  }
}

async function callTransport(message, level) {
  transports.forEach(({ minimumLevel, func, name }) => {
    if (level > minimumLevel) {
      return;
    }

    executeSingleTransport(func, message, level, name);
  });
}

export function debug(message) {
  callTransport(message, severity.debug);
}

export function info(message) {
  callTransport(message, severity.info);
}

export function notice(message) {
  callTransport(message, severity.notice);
}

export function warning(message) {
  callTransport(message, severity.warning);
}

export function error(message) {
  callTransport(message, severity.error);
}

export function critical(message) {
  callTransport(message, severity.critical);
}

export function alert(message) {
  callTransport(message, severity.alert);
}

export function emergency(message) {
  callTransport(message, severity.emergency);
}

export function addTransport(name, level, transport) {
  transports.push({
    name,
    func: transport,
    minimumLevel: level
  });
}